/* ─── 팜인사이트 안내 레이아웃 — Figma 767:26756 (p24는 부모, 블록 gap 24) ───
   데이터: GET /pharminsight/guide 응답 data (guide prop) */

const asText = v => (typeof v === 'string' ? v : v?.text || v?.body || '');

// "문장. 문장." → ["문장.", "문장."]
const toSentences = text =>
  String(text || '')
    .split(/(?<=[.!?])\s+/)
    .map(s => s.trim())
    .filter(Boolean);

// cautions / checks.monitor / checks.counsel — 그룹 { ingredient_name|name, rules:[{title, body}] }
// (cautions·counsel 실응답 미확인 → 같은 형태로 가정, 필드 없으면 빈 카드는 버림)
const toCards = groups =>
  (Array.isArray(groups) ? groups : [])
    .map(g => ({
      title: g?.ingredient_name || g?.name || g?.rules?.[0]?.title || '',
      lines: (Array.isArray(g?.rules) ? g.rules : [g]).flatMap(r => toSentences(r?.body)),
    }))
    .filter(c => c.title || c.lines.length > 0);

const IconCommentMedical = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="shrink-0" aria-hidden>
    <path d="M8 14C12.4187 14 16 11.0906 16 7.5C16 3.90937 12.4187 1 8 1C3.58125 1 0 3.90937 0 7.5C0 8.90937 0.553125 10.2125 1.49062 11.2781C1.43125 12.0437 1.13437 12.725 0.821875 13.2437C0.65 13.5312 0.475 13.7625 0.346875 13.9187C0.28125 13.9969 0.23125 14.0563 0.19375 14.0969L0.14375 14.15C0 14.2937 -0.040625 14.5063 0.0375 14.6938C0.115625 14.8813 0.296875 15.0031 0.5 15.0031C1.39688 15.0031 2.3 14.725 3.05 14.4C3.76563 14.0875 4.375 13.7156 4.74687 13.4438C5.74062 13.8031 6.84062 14.0031 8 14.0031V14ZM7 5C7 4.725 7.225 4.5 7.5 4.5H8.5C8.775 4.5 9 4.725 9 5V6.5H10.5C10.775 6.5 11 6.725 11 7V8C11 8.275 10.775 8.5 10.5 8.5H9V10C9 10.275 8.775 10.5 8.5 10.5H7.5C7.225 10.5 7 10.275 7 10V8.5H5.5C5.225 8.5 5 8.275 5 8V7C5 6.725 5.225 6.5 5.5 6.5H7V5Z" fill="#A1A1AA" />
  </svg>
);

const IconAlert = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className="shrink-0" aria-hidden>
    <path fillRule="evenodd" clipRule="evenodd" d="M16.5 9C16.5 4.85775 13.1422 1.5 9 1.5C4.85775 1.5 1.5 4.85775 1.5 9C1.5 13.1422 4.85775 16.5 9 16.5C13.1422 16.5 16.5 13.1422 16.5 9ZM9 5.25C9.41421 5.25 9.75 5.58579 9.75 6V9.75C9.75 10.1642 9.41421 10.5 9 10.5C8.58579 10.5 8.25 10.1642 8.25 9.75V6C8.25 5.58579 8.58579 5.25 9 5.25ZM8.25 12C8.25 11.5858 8.58579 11.25 9 11.25H9.006C9.42021 11.25 9.756 11.5858 9.756 12C9.756 12.4142 9.42021 12.75 9.006 12.75H9C8.58579 12.75 8.25 12.4142 8.25 12Z" fill="#F04351" fillOpacity="0.8" />
  </svg>
);

const IconQuestion = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className="shrink-0" aria-hidden>
    <path d="M9 16.6841C13.1963 16.6841 16.6841 13.2036 16.6841 9C16.6841 4.80375 13.1885 1.31593 8.99229 1.31593C4.78896 1.31593 1.31625 4.80375 1.31625 9C1.31625 13.2036 4.79636 16.6841 9 16.6841ZM8.85729 10.6348C8.44264 10.6348 8.22407 10.4239 8.22407 10.017V9.91157C8.22407 9.13564 8.63871 8.71361 9.21118 8.32211C9.91189 7.84736 10.2359 7.57639 10.2359 7.03382C10.2359 6.43854 9.76854 6.03193 9.04532 6.03193C8.52557 6.03193 8.12636 6.2955 7.88529 6.72493C7.62911 7.02611 7.55389 7.25979 7.10196 7.25979C6.84579 7.25979 6.55939 7.07143 6.55939 6.71721C6.55939 6.58189 6.58961 6.45364 6.62721 6.32571C6.83068 5.59479 7.74225 4.96221 9.09836 4.96221C10.4468 4.96221 11.6145 5.66293 11.6145 6.97339C11.6145 7.92257 11.0645 8.37482 10.296 8.89457C9.75375 9.26357 9.48246 9.53486 9.48246 9.97939V10.0774C9.48246 10.386 9.24879 10.6348 8.85729 10.6348ZM8.87979 12.9025C8.45036 12.9025 8.03604 12.556 8.03604 12.0886C8.03604 11.6212 8.44264 11.2754 8.87979 11.2754C9.32432 11.2754 9.72354 11.6142 9.72354 12.0886C9.72354 12.5634 9.31661 12.9025 8.87979 12.9025Z" fill="#F79103" />
  </svg>
);

const IconCheck = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className="shrink-0" aria-hidden>
    <circle cx="9" cy="9" r="8.25" fill="#1D356D" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14.0193 5.48105C14.167 5.62886 14.25 5.82932 14.25 6.03833C14.25 6.24734 14.167 6.44779 14.0193 6.59561L8.11351 12.5037C7.79826 12.8189 7.24004 12.8189 6.92479 12.5037L3.99055 9.56882C3.66896 9.25821 3.6662 8.74437 3.98078 8.44449C4.29536 8.14461 4.80156 8.14961 5.10468 8.45426L7.51889 10.8694L12.9046 5.48105C13.2124 5.17305 13.7116 5.17305 14.0193 5.48105Z" fill="white" />
  </svg>
);

const IconBasket = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className="shrink-0" aria-hidden>
    <path d="M15.996 6H13.8L13.332 3.204C13.2377 2.78096 13.0306 2.39136 12.7327 2.07655C12.4348 1.76174 12.0572 1.53348 11.64 1.416C11.2207 1.28181 10.7842 1.20906 10.344 1.2H7.656C7.21584 1.20906 6.77931 1.28181 6.36 1.416C5.9428 1.53348 5.56521 1.76174 5.2673 2.07655C4.96939 2.39136 4.7623 2.78096 4.668 3.204L4.2 6H2.004C1.66 6 1.33 6.4 1.428 6.78L3.684 14.34C3.79885 14.7052 4.02716 15.0243 4.33576 15.2509C4.64435 15.4775 5.01715 15.5998 5.4 15.6H12.6C12.9808 15.5972 13.3509 15.4738 13.6571 15.2474C13.9633 15.0209 14.1898 14.7033 14.304 14.34L16.56 6.78C16.66 6.4 16.36 6 15.996 6ZM5.424 6L5.856 3.396C5.90336 3.18339 6.01322 2.9898 6.17146 2.84011C6.3297 2.69042 6.52909 2.59148 6.744 2.556C7.0392 2.4624 7.3464 2.4108 7.656 2.4H10.344C10.6584 2.4104 10.9664 2.4624 11.268 2.556C11.4829 2.59148 11.6823 2.69042 11.8405 2.84011C11.9988 2.9898 12.1086 3.18339 12.156 3.396L12.576 6H5.424Z" fill="#18181B" />
  </svg>
);

/* 767:26764 title — 아이콘 18 + gap4 + SB16 */
const BlockTitle = ({ icon, color, children }) => (
  <div className="flex w-full items-center gap-1">
    {icon}
    <p className="min-w-0 flex-1 text-16 font-semibold tracking-[-0.32px]" style={{ color }}>
      {children}
    </p>
  </div>
);

/* 767:26767 list_container — 2열 grid gap8, 카드 border r8 p12 gap4, 제목 SB15 #52525b, 본문 disc R14/lh22 */
const RuleCardBlock = ({ icon, title, color, border, cards }) => (
  <section className="flex w-full flex-col gap-2">
    <BlockTitle icon={icon} color={color}>{title}</BlockTitle>
    <div className="grid w-full grid-cols-2 items-start gap-2 text-[#52525b]">
      {cards.map((c, i) => (
        <div
          key={`${c.title}-${i}`}
          className="flex flex-col gap-1 rounded-lg border bg-white p-3"
          style={{ borderColor: border }}
        >
          <p className="text-15 font-semibold tracking-[-0.3px]">{c.title}</p>
          {c.lines.length > 0 && (
            <ul className="list-disc text-14-long tracking-[-0.28px]">
              {c.lines.map((l, j) => (
                <li key={j} className="ms-[21px]">{l}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  </section>
);

/* 767:26797 card — border #f5f5f5 r8 p8 gap12, 이미지 h110 r6 bg #f3f3f3, 정보 py4 gap12 */
const SupplementCard = ({ s }) => {
  // "월 N개" — API 미제공(pharmacy_sale_qty는 90일·디버그용). monthly_sale_qty 추가되면 자동 노출
  const monthly = s?.monthly_sale_qty;
  const efficacy = s?.guide_text || s?.function_name;
  const notice = asText(s?.extra_notice);
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-3 rounded-lg border border-[#f5f5f5] bg-white p-2">
      <div className="h-[110px] w-full shrink-0 overflow-hidden rounded-[6px] bg-[#f3f3f3]">
        {s?.image_url && (
          <img
            src={s.image_url}
            alt={s.name}
            className="size-full rounded-[6px] object-contain"
            onError={e => { e.currentTarget.style.display = 'none'; }}
          />
        )}
      </div>
      <div className="flex w-full flex-col gap-3 overflow-hidden py-1">
        <div className="flex w-full flex-col">
          <p className="truncate text-15 font-medium tracking-[-0.3px] text-[#18181b]">{s?.name}</p>
          {monthly != null && (
            <p className="truncate text-12 text-[#71717a]">월 {Number(monthly).toLocaleString()}개</p>
          )}
        </div>
        {efficacy && (
          <p className="text-14 font-medium tracking-[-0.28px] text-[#52525b]">{efficacy}</p>
        )}
        {notice && (
          <p className="text-14 font-medium tracking-[-0.28px] text-[#f04351]">* {notice}</p>
        )}
      </div>
    </div>
  );
};

/* tag — px6 r4 SB14 */
const Tag = ({ bg, color, children }) => (
  <span
    className="inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded px-1.5 text-14 font-semibold tracking-[-0.28px]"
    style={{ background: bg, color }}
  >
    {children}
  </span>
);

/* 767:26841 card — border #f5f5f5 r8 p12 gap12, 왼쪽 w180 (제품명 M15 + 제조사·성분 R12) */
const PurchaseCheckCard = ({ item }) => {
  const sub = [item?.manufacturer || item?.category, item?.ingredient_name || item?.ingredient]
    .filter(Boolean)
    .join(' · ');
  const warnings = (Array.isArray(item?.warnings) ? item.warnings : [])
    .map(w => (Array.isArray(w?.lines) ? w.lines : toSentences(asText(w))))
    .filter(lines => lines.length > 0);
  const sg = item?.surgery_guide;
  const surgery = sg
    ? typeof sg === 'string'
      ? { label: '수술 전 확인', check: '', guide: sg }
      : { label: sg.label || '수술 전 확인', check: sg.check || '', guide: sg.guide || '' }
    : null;

  return (
    <div className="flex w-full items-start gap-3 rounded-lg border border-[#f5f5f5] bg-white p-3">
      <div className="flex w-[180px] shrink-0 flex-col">
        <p className="truncate text-15 font-medium tracking-[-0.3px] text-[#18181b]">{item?.name}</p>
        {sub && <p className="truncate text-12 text-[#71717a]">{sub}</p>}
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-4">
        {warnings.map((lines, i) => (
          <div key={i} className="flex w-full items-start gap-2">
            <Tag bg="#fdecee" color="#f04351">주의</Tag>
            <div className="flex min-w-[120px] flex-1 flex-col gap-0.5 text-14 font-medium tracking-[-0.28px] text-[#71717a]">
              {lines.map((l, j) => <p key={j}>{l}</p>)}
            </div>
          </div>
        ))}
        {surgery && (
          <div className="flex w-full flex-col items-start gap-1">
            <Tag bg="#fef1e2" color="#f79103">{surgery.label}</Tag>
            <div className="flex w-full flex-col gap-2 text-14 tracking-[-0.28px]">
              {[['확인', surgery.check], ['안내', surgery.guide]].filter(([, v]) => v).map(([k, v]) => (
                <div key={k} className="flex w-full flex-wrap items-start gap-x-3">
                  <p className="w-6 shrink-0 font-semibold text-[#a1a1aa]">{k}</p>
                  <p className="min-w-[120px] flex-1 font-medium text-[#71717a]">{v}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const GuideLayout = ({ guide, loading }) => {
  const summary = guide?.situation_text;
  const cautions = toCards(guide?.cautions);
  const checks = [...toCards(guide?.checks?.monitor), ...toCards(guide?.checks?.counsel)];
  const supplements = (Array.isArray(guide?.supplements) ? guide.supplements : []).slice(0, 3);
  const purchaseChecks = Array.isArray(guide?.purchase_checks) ? guide.purchase_checks : [];
  const empty = !summary && !cautions.length && !checks.length && !supplements.length && !purchaseChecks.length;

  // Figma 721:14499 디자이너 메모: 빈 층은 그리지 않고 「없습니다」 안내 줄도 넣지 않는다
  if (empty) return null;

  return (
    <div className="flex w-full flex-col gap-6">
      {/* ① 767:26757 처방 기반 요약 */}
      {summary && (
        <section className="flex w-full flex-col gap-1">
          <div className="flex w-full items-center gap-1">
            <IconCommentMedical />
            <p className="text-12 font-semibold text-[#71717a]">처방 기반 요약</p>
          </div>
          <p className="w-full text-18 font-semibold tracking-[-0.36px] text-[#3f3f46]">{summary}</p>
        </section>
      )}

      {/* ② 767:26763 함께 복용 주의 */}
      {cautions.length > 0 && (
        <RuleCardBlock icon={<IconAlert />} title="함께 복용할 때 주의가 필요해요" color="#f04351" border="#fdecee" cards={cautions} />
      )}

      {/* ③ 767:26780 확인 필요 */}
      {checks.length > 0 && (
        <RuleCardBlock icon={<IconQuestion />} title="확인이 필요해요" color="#f79103" border="#fef1e2" cards={checks} />
      )}

      {/* ④ 767:26792 함께 복용 가능 제품 */}
      {supplements.length > 0 && (
        <section className="flex w-full flex-col gap-2">
          <BlockTitle icon={<IconCheck />} color="#1d356d">처방과 함께 복용할 수 있는 제품이에요</BlockTitle>
          <div className="flex w-full items-start gap-2">
            {supplements.map((s, i) => <SupplementCard key={s?.product_code || i} s={s} />)}
          </div>
        </section>
      )}

      {/* ⑤ 767:26835 함께 사는 제품 — basket 미연결로 대부분 비어 숨김 */}
      {purchaseChecks.length > 0 && (
        <section className="flex w-full flex-col gap-2">
          <BlockTitle icon={<IconBasket />} color="#18181b">함께 사는 제품 안내예요</BlockTitle>
          <div className="flex w-full flex-col gap-2">
            {purchaseChecks.map((item, i) => (
              <PurchaseCheckCard key={item?.product_code || item?.barcode || i} item={item} />
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

/* AI 맞춤 추천 — 환자관리 상세 · POS/홈 환자 모달 공용 (guide = 팜인사이트 안내 응답 data) */
export const AiRecommendationContent = ({ guide, loading }) => <GuideLayout guide={guide} loading={loading} />;
